import { lazy, Suspense } from "react"
import { useProfile } from "../contexts/ProfileContextProvider"
const SearchPageContent = lazy(
    () => import("../components/SearchPageComponents/SearchPageContent"),
)
function Saved() {
    const { favorites } = useProfile()
    return (
        <Suspense fallback={<div></div>}>
            <SearchPageContent
                data={favorites}
                title={"Mina Favoriter"}
                notFoundTitle={"Inga Favoriter sparade"}
                doFiltering={false}
            />
        </Suspense>
    )
}

export default Saved
